import { SET_SAVE_FOR_LATER_SYNCING } from "../../types";

const setSaveForLaterSyncing = (order, deleteOrder) => (dispatch) => {
  dispatch({ type: SET_SAVE_FOR_LATER_SYNCING, order, deleteOrder });
};

export { setSaveForLaterSyncing };
